import React, { useState } from "react";
import Dialog from '@material-ui/core/Dialog';
import {
    Box, Button, DialogContent, InputAdornment, Collapse
} from '@material-ui/core';
import { useTranslate } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { Close } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core';
import { useDataProvider } from 'react-admin';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import colors from '../CustomizedUIs/Colors';
import { useHistory } from 'react-router-dom';
import { Alert } from '@material-ui/lab';
import CustomTextField from './CustomTextField'
import TextButton from "../CustomizedUIs/TextButton";
import CloseButton from "../CustomizedUIs/CloseButton";

const useStyles = makeStyles(theme => ({
    dialog: {
        width: 573,
        borderRadius: 10,
        backgroundColor: '#f3f7fa'
    },
    dialogCloseBtn: {
        backgroundColor: theme.palette.common.white,
        marginLeft: 10
    },
    dialogContent: {
        paddingLeft: 32,
        paddingRight: 35
    },
    levelItem: {
        height: '45px',
        paddingLeft: '4rem'
    },
    expandGroup: {
        width: 241,
        height: 30,
        float: 'right',
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around'
    },
    expandText: {
        fontSize: 10,
    }, underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }, fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    }, Header: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    }, btnClose: {
        fontFamily: 'UniviaPro',
        fontSize: '10px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.4px',
        color: '#4f5064',
    }, btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '5px'
    }
}));

const UpdatePassword = ({ open, handleClose, id }) => {
    const translate = useTranslate();
    const classes = useStyles();
    const dataProvider = useDataProvider();
    const history = useHistory();
    const [isSend, setIsSend] = useState(false);
    const [message, setMessage] = useState("");
    const [openAlert, setOpenAlert] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConformPassword, setShowConformPassword] = useState(false);
    // const [newpassword, setNewPassWord] = useState({ showNewPassword: false, });
    // const [conformpassword, setConformPassWord] = useState({ showFormPassword: false, });
    const [textValue, setTextValue] = React.useState({
        passwordInput: '',
        passwordNewInput: '',
        passwordConformInput: '',
    });
    const [validate, setValidate] = React.useState({
        passwordInput: {
            isError: true,
            message: ''
        },
        passwordNewInput: {
            isError: true,
            message: ''
        },
        passwordConformInput: {
            isError: true,
            message: ''
        }

    });

    // const handlePasswordInput = prop = (e) => {
    //     setPasswordInput(e.target.value),
    //     validateFc(prop, e.target.value)
    // }
    // const handleNewPasswordInput = (e) => {
    //     setPasswordNewInput(e.target.value);
    //     validateFc(prop, e.target.value)
    // }
    // const handleConformPasswordInput = (e) => {
    //     setPasswordConformInput(e.target.value);
    //     validateFc(prop, e.target.value)
    // }
    const textOnChange = prop => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validateFc(prop, e.target.value)
    }
    const handleCloseDialog = () => {
        setShowPassword(false);
        setShowNewPassword(false);
        setShowConformPassword(false);
        setValidate({
            passwordInput: {
                isError: true,
                message: ''
            },
            passwordNewInput: {
                isError: true,
                message: ''
            },
            passwordConformInput: {
                isError: true,
                message: ''
            }
        })
        setTextValue({
            passwordInput: '',
            passwordNewInput: '',
            passwordConformInput: '',
        });
        setIsSend(false);
        setMessage(false);
        setOpenAlert(false);
        handleClose();
    }

    const changePassword = () => {
        dataProvider('UPDATE', 'users', {
            id: id,
            data: {
                oldpassword: textValue.passwordInput,
                password: textValue.passwordConformInput,
            }
        }).then(({ users }) => {
            history.push({
                pathname: '/users',
                state: { open: true }
            });
        }).catch(response => {
            // TODO: Should show error message
            setIsSend(false);
            setOpenAlert(true)
            setMessage(translate(response.message));
        });

    }

    // show password
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    // show new password
    const handleClickShowNewPassword = () => {
        setShowNewPassword(!showNewPassword);
    };
    const handleMouseDownNewPassword = (event) => {
        event.preventDefault();
    };
    // show conform password
    const handleClickShowConformPassword = () => {
        setShowConformPassword(!showConformPassword);
    };
    const handleMouseDownConformPassword = (event) => {
        event.preventDefault();
    };
    const validateFc = (prop, value) => {
        if (prop === 'passwordInput') {
            if (value.length === 0) {
                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                            isError: false, message: ''
                        }
                })
            }
        }
        else if (prop === 'passwordNewInput') {
            if (value.length === 0) {
                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                            isError: false, message: ''
                        }
                })
            }
            if (value.length < 6 ) {
                setValidate({
                    ...validate, [prop]: value.length < 6 ? {
                        isError: true, message: translate('pos.auth.errorlongcharacter')
                    } : {
                            isError: false, message: ''
                        }
                })
            }
            if (value.length >= 6 ) {
                setValidate({
                    ...validate, [prop]: !(value.match(/[a-z]/) && value.match(/[A-Z]/)
                        && value.match(/[0-9]/) && value.match(/[`!@#$%^&*_()+\-=\[\]{};':"\\|,.<>\/?~]/)) ? {
                            isError: true, message: translate('pos.auth.errorspecial')
                        } : {
                            isError: false, message: ''
                        }
                })
            }
            if (value !== textValue.passwordConformInput && textValue.passwordConformInput !== '' && !validate.passwordConformInput.isError) {
                setValidate({
                    ...validate, passwordConformInput: value !== textValue.passwordConformInput ? {
                        isError: true, message: translate('pos.auth.checkrepeatpassword'),

                    } : {
                            isError: false, message: ''
                        }
                });
            }
        }
        else if (prop === 'passwordConformInput') {
            if (value.length === 0)
                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                            isError: false, message: ''
                        }
                })
            else {
                setValidate({
                    ...validate, [prop]: value !== textValue.passwordNewInput ? {
                        isError: true, message: translate('pos.auth.checkrepeatpassword'),

                    } : {
                            isError: false, message: ''
                        }
                })

            }

        }
        else
            setValidate({
                ...validate, [prop]: value.length === 0 ? {
                    isError: true, message: 'required'
                } : {
                        isError: false, message: ''
                    }
            })

    }


    return (

        <Dialog open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" >
            <Box className={classes.dialog}>

                <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} mt={1}>
                    <Typography className={classes.btnClose}>{translate('pos.user.close')}</Typography>
                    <CloseButton onClick={handleCloseDialog}/>
                </Box>
                <DialogContent className={classes.dialogContent}>
                    <Typography className={classes.Header}>{translate('pos.user.changePassword')}</Typography>
                    <Box mt={2}  >
                        <Collapse in={openAlert}>
                            <Alert severity={isSend ? "success" : "error"} >{message}</Alert>
                        </Collapse>
                    </Box>

                    <Box mt={2.25} display="flex" justifyContent='space-between' alignItems='center'>

                        <CustomTextField margin="normal"
                            required
                            label="Old password"
                            onBlur={() => {
                                validateFc('passwordInput', textValue.passwordInput)
                            }}
                            value={textValue.passwordInput}
                            error={validate.passwordInput.message !== "" && validate.passwordInput.isError}
                            helperText={validate.passwordInput.message}
                            fullWidth
                            onChange={textOnChange('passwordInput')}
                            variant="filled"
                            type={showPassword ? 'text' : 'password'}
                            endDom={
                                <InputAdornment position="end">
                                    <IconButton
                                        size='small'
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                    >
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>}></CustomTextField>
                    </Box>
                    <Box display="flex" justifyContent='space-between' alignItems='center'>
                        <CustomTextField margin="normal"
                            required
                            label="New password"
                            onBlur={() => {
                                validateFc('passwordNewInput', textValue.passwordNewInput)
                            }}
                            value={textValue.passwordNewInput}
                            error={validate.passwordNewInput.message !== "" && validate.passwordNewInput.isError}
                            helperText={validate.passwordNewInput.message}
                            fullWidth
                            onChange={textOnChange('passwordNewInput')}
                            variant="filled"
                            type={showNewPassword ? 'text' : 'password'}
                            endDom={
                                <InputAdornment position="end">
                                    <IconButton
                                        size='small'
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowNewPassword}
                                        onMouseDown={handleMouseDownNewPassword}
                                    >
                                        {showNewPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>}></CustomTextField>
                    </Box>
                    <Box display="flex" justifyContent='space-between' alignItems='center'>
                        <CustomTextField margin="normal"
                            required
                            onBlur={() => {
                                validateFc('passwordConformInput', textValue.passwordConformInput)
                            }}
                            value={textValue.passwordConformInput}
                            error={validate.passwordConformInput.message !== "" && validate.passwordConformInput.isError}
                            helperText={validate.passwordConformInput.message}
                            disabled={(textValue.passwordNewInput === ""||validate.passwordNewInput.message !== "" && validate.passwordNewInput.isError)&&true}
                            label="Repeat new password"
                            fullWidth
                            onChange={textOnChange('passwordConformInput')}
                            variant="filled"
                            type={showConformPassword ? 'text' : 'password'}
                            endDom={
                                <InputAdornment position="end">
                                    <IconButton
                                        size='small'
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowConformPassword}
                                        onMouseDown={handleMouseDownConformPassword}
                                    >
                                        {showConformPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>}></CustomTextField>
                    </Box>
                    <Box display='flex' fullWidth justifyContent='flex-end' mt={3} mb={3}>
                        <Box display='flex' alignItems='flex-end' mr={3} onClick={handleCloseDialog} >
                            <TextButton mt={3}/>
                               
                        </Box>
                        <Button mt={3} variant="contained" color="primary"
                            disabled={validate.passwordInput.message !== "" || validate.passwordNewInput.message !== "" || validate.passwordConformInput.message !== ""
                                || textValue.passwordInput === "" || textValue.passwordNewInput === "" || textValue.passwordConformInput === "" ? true : false}
                            onClick={changePassword} >
                            <Typography className={classes.btnCreate}> {translate(`pos.user.CreateNewPassword`)}</Typography>
                        </Button>
                    </Box>
                </DialogContent>
            </Box>
        </Dialog>

    );
}
export default UpdatePassword